module.exports = __webpack_public_path__ + "d57a46ccf8c4b381e0efd68fca5b4eed.jpg";